import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';

export default function CatalogList() {
  const [catalogs, setCatalogs] = useState([]);

  useEffect(() => {
    axios.get('/catalogs/catalog-list.json').then(res => setCatalogs(res.data));
  }, []);

  return (
    <div>
      <h2>Catalog ทั้งหมด</h2>
      <ul>
        {catalogs.map(c => (
          <li key={c.id}>
            <Link to={`/test-catalog/${c.id}`}>
              <img src={c.cover} alt={c.title} style={{ width: 200 }} />
              <div>{c.title}</div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
